module.exports = __webpack_public_path__ + "img/step-3.8e2c7426.jpg";